import React, { Component, Fragment } from "react";

import { PieChart, Pie, Cell } from "recharts";

import { Metric, Error } from "./../../../Utils/Utils.js";

import numeral from "./../../../../../node_modules/numeraljs/numeral.js";
import SharedSocialLineChart from "./../../LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

const COLORS = ["#f4f4f4", "#16C8DE"];

class SnapChat extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: this.childRef.getExportData().data,
    opts: {
      type: "chart",
      date: { name: "name" },
      values: ["current_value", "previous_value"],
    },
  });

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Views</h6>
            <Metric {...data.stats.viewers} size={"md"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Avg Views Per Ep</h6>
            <Metric {...data.stats.minutes_viewed} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Avg View Length</h6>
            <Metric {...data.stats.avg_duration} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Net New Subs</h6>
            <Metric {...data.stats.avg_duration} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Shares</h6>
            <Metric {...data.stats.avg_duration} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Screenshots</h6>
            <Metric {...data.stats.avg_duration} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-3 mb-3">
            <h6 className="widget__metric-label">Unique Viewers</h6>
            <Metric {...data.stats.avg_duration} size={"sm"} />
          </div>

          <div className="col-6 col-md-6">
            <h6 className="widget__metric-label m-0">% Complete</h6>
            <PieChart height={45} width={45}>
              <Pie
                dataKey="value"
                data={data.stats.paid}
                outerRadius="100%"
                innerRadius="75%"
              >
                {data.stats.paid.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {numeral(data.stats.paid[1].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>
        </div>
        ,
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={data.graph}
          color={"#16C8DE"}
        />
      </Fragment>
    );
  }
}

export default SnapChat;
